/**
 * Formats a message by converting URLs into clickable links
 * @param {string} message - The message text to format
 * @returns {string} - HTML string with formatted links
 */
export const formatMessageWithLinks = (message) => {
  if (!message) return '';
  
  // URL regex pattern
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  
  // Replace URLs with anchor tags
  return message.replace(urlPattern, url => {
    return `<a href="${url}" target="_blank" class="message-link">${url}</a>`;
  });
}; 